const imageStyles = { width: '80px', height: '60px' }

export { imageStyles }
